
const DB_NAME = 'RamNaamBank_LargeStorage';
const EBOOKS_STORE = 'ebooks';
const AUDIOS_STORE = 'audios';
const VIDEOS_STORE = 'videos';
const USERS_STORE = 'users';
const NIDHI_SCANS_STORE = 'nidhi_scans';
const BLOGS_STORE = 'blogs';
const BLOG_CATEGORIES_STORE = 'blog_categories';
const DB_VERSION = 8;

let dbInstance: IDBDatabase | null = null;

export const openDB = (): Promise<IDBDatabase> => {
  if (dbInstance) return Promise.resolve(dbInstance);

  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = (event: any) => {
      const db = request.result;
      if (!db.objectStoreNames.contains(EBOOKS_STORE)) {
        db.createObjectStore(EBOOKS_STORE, { keyPath: 'id' });
      }
      if (!db.objectStoreNames.contains(AUDIOS_STORE)) {
        db.createObjectStore(AUDIOS_STORE, { keyPath: 'id' });
      }
      if (!db.objectStoreNames.contains(VIDEOS_STORE)) {
        db.createObjectStore(VIDEOS_STORE, { keyPath: 'id' });
      }
      if (!db.objectStoreNames.contains(USERS_STORE)) {
        db.createObjectStore(USERS_STORE, { keyPath: 'username' });
      }
      if (!db.objectStoreNames.contains(NIDHI_SCANS_STORE)) {
        db.createObjectStore(NIDHI_SCANS_STORE, { keyPath: 'id' });
      }
      if (!db.objectStoreNames.contains(BLOGS_STORE)) {
        db.createObjectStore(BLOGS_STORE, { keyPath: 'id' });
      }
      if (!db.objectStoreNames.contains(BLOG_CATEGORIES_STORE)) {
        db.createObjectStore(BLOG_CATEGORIES_STORE, { keyPath: 'id' });
      }
    };

    request.onsuccess = () => {
      dbInstance = request.result;
      dbInstance.onversionchange = () => {
        dbInstance?.close();
        dbInstance = null;
      };
      resolve(dbInstance);
    };

    request.onerror = () => {
      console.error("IndexedDB Open Error:", request.error);
      reject(request.error);
    };
  });
};

export const getAllFromStore = async <T>(storeName: string): Promise<T[]> => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    try {
      const transaction = db.transaction(storeName, 'readonly');
      const store = transaction.objectStore(storeName);
      const request = store.getAll();

      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    } catch (e) {
      reject(e);
    }
  });
};

export const getOneFromStore = async <T>(storeName: string, key: string): Promise<T | null> => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    try {
      const transaction = db.transaction(storeName, 'readonly');
      const store = transaction.objectStore(storeName);
      const request = store.get(key);

      request.onsuccess = () => resolve(request.result || null);
      request.onerror = () => reject(request.error);
    } catch (e) {
      reject(e);
    }
  });
};

export const saveToStore = async <T>(storeName: string, data: T): Promise<void> => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    try {
      const transaction = db.transaction(storeName, 'readwrite');
      const store = transaction.objectStore(storeName);
      const request = store.put(data);

      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error);
    } catch (e) {
      reject(e);
    }
  });
};

export const saveMultipleToStore = async <T>(storeName: string, items: T[]): Promise<void> => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    try {
      const transaction = db.transaction(storeName, 'readwrite');
      const store = transaction.objectStore(storeName);
      
      items.forEach(item => {
        store.put(item);
      });

      transaction.oncomplete = () => resolve();
      transaction.onerror = () => reject(transaction.error);
    } catch (e) {
      reject(e);
    }
  });
};

export const deleteFromStore = async (storeName: string, id: string): Promise<void> => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    try {
      const transaction = db.transaction(storeName, 'readwrite');
      const store = transaction.objectStore(storeName);
      const request = store.delete(id);

      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error);
    } catch (e) {
      reject(e);
    }
  });
};
